module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/user-devices/user-devices.template.html
// module id = 848
// module chunks = 2